<script>
  import AbstractField from '@/components/Fields/AbstractTextField'

  export default {
    mixins: [AbstractField],
    data () {
      return {
        type: 'masked-field'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// MaskedField.vue?75692920